import * as React from "react";
import type { QueryClient } from "@tanstack/react-query";
import type { NormalizerConfig } from "./core";

import { createQueryNormalizer } from "./create-query-normalizer";
import { QueryNormalizerContext } from "./useQueryNormalizer";

export function QueryNormalizerProvider({
	queryClient,
	normalizerConfig,
	children,
}: {
	queryClient: QueryClient;
	children: React.ReactNode;
	normalizerConfig?: Omit<NormalizerConfig, "structuralSharing"> & {
		normalize?: boolean;
	};
}) {
	const [queryNormalizer] = React.useState(() =>
		createQueryNormalizer(queryClient, normalizerConfig),
	);

	React.useEffect(() => {
		queryNormalizer.subscribe();

		return () => {
			queryNormalizer.unsubscribe();
			queryNormalizer.clear();
		};
	}, [queryNormalizer]);

	return (
		<QueryNormalizerContext.Provider value={queryNormalizer}>
			{children}
		</QueryNormalizerContext.Provider>
	);
}
